import { PropertyMasterSettingsDTO } from "../DTO/propertyMasterSettingsDTO";

export class PropertyMasterSettings{
    public propertyId!:number;
    public settingsData!:PropertyMasterSettingsData;
    
    constructor(){
        this.settingsData=new PropertyMasterSettingsData();
    }

    public static mapToDTO(param:PropertyMasterSettings) : PropertyMasterSettingsDTO{
        
        let dto = new PropertyMasterSettingsDTO();
        try
        {
            dto.propertyId = param.propertyId;
            dto.settings = JSON.stringify(param.settingsData, (key, value) => value ?? undefined);
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyMasterSettingsDTO) : PropertyMasterSettings
    {
        
        let obj = new PropertyMasterSettings();
        try
        {
            obj.propertyId = param.propertyId;
            if(param.settings) {
                let data = <PropertyMasterSettingsData>JSON.parse(param.settings);
                obj.settingsData = Object.assign(new PropertyMasterSettingsData(),data);
            }
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}

export class PropertyMasterSettingsData{
    public partiesSectionShow:string[]=[];
    public tasksSectionShow:string[]=[];
    public preservationSectionShow:string[]=[];
    public managementSectionShow:string[]=[];
    public saleSectionShow:string[]=[];
}